module.exports = __webpack_public_path__ + "static/media/vice-president.e9ce8a9e.png";